var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"src":'@/assets/images/logo/myclinic-rec-1.png',"width":"80px","alt":"","srcset":""}})}
var staticRenderFns = []

export { render, staticRenderFns }